import React, {Component} from 'react';
import HeaderComponent
    from "../../../../Components/HeaderComponent/HeaderComponent";
import {Typography} from "@material-ui/core";
import SpacerComponent
    from "../../../../Components/SpacerComponent/SpacerComponent";
import CreateFormMensageriaComponent from "./CreateFormMensageriaComponent";
import TableCreateFormMensageriaComponente
    from "./TableCreateFormMensageriaComponente";
import FooterMensageriaComponent from "./FooterMensageriaComponent";
import MessageService from "../../../../Services/MessageService";
import MessageUtil from "../../../../Utils/MessageUtil";
import MessageValidation from "../../../../FormValidations/MessageValidation";
import GeneralTranslation from "../../../../Translations/FormValidations/GeneralTranslation";


class CreateMensageriaScreen extends Component {
    static ROUTE = '/mensageria-criar';

    constructor(props) {
        super(props);

        this.state = {
            inLoad: false,
            messagens: null,
            erros: {},
            clients: [],
            pagination: null,
            search: '',
            form: {
                subject: '',
                body: '',
            },
            selectedClients: [],
            sendToAll: false,
            isConfirmationOpen: false,
        };
        this.messageService = new MessageService();
    }

    componentDidMount() {
        this.load();
    }

    async load(page = 1, search = this.state.search) {
        try {
            this.setState({
                inLoad: true,
                search: search,
            });

            const clients = await this.messageService.getClients(
                {page: page, search: search}
            );

            this.setState({
                inLoad: false,
                clients: clients.data.data,
                pagination: clients.data.meta,
            });


        } catch (e) {
            this.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Atenção',
                    body: e,
                }),
            });
        }
    }

    handleChangeForm = (event) => {
        const {name, value} = event.target;
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [name]: value
            }
        }));
    };

    handleSelectClient = (clientUuid) => {
        this.setState(prevState => {
            const currentSelected = prevState.selectedClients;
            const exists = currentSelected.includes(clientUuid);
            let updated;

            if (exists) {
                updated = currentSelected.filter(id => id !== clientUuid);
            } else {
                updated = [...currentSelected, clientUuid];
            }

            return { selectedClients: updated };
        });
    };

    handleSelectAllCurrentPage = (currentPageClients = []) => {
        this.setState(prevState => {
            const currentSelected = prevState.selectedClients;
            const currentPageUuids = currentPageClients.map(c => c.uuid);
            const allSelected = currentPageUuids.length > 0 && currentPageUuids.every(id => currentSelected.includes(id));

            let updated;
            if (allSelected) {
                updated = currentSelected.filter(id => !currentPageUuids.includes(id));
            } else {
                const newUuids = currentPageUuids.filter(id => !currentSelected.includes(id));
                updated = [...currentSelected, ...newUuids];
            }

            return { selectedClients: updated };
        });
    };

    handleToggleSendToAll = (event) => {
        const checked = event.target ? event.target.checked : !this.state.sendToAll;
        this.setState({ sendToAll: checked });
    };

    handleReviewAndSend = async () => {
        try {
            const objectToValidate = {
                subject: this.state.form.subject,
                body: this.state.form.body,
                send_to_all: this.state.sendToAll,
                client_uuids: this.state.selectedClients,
            };

            const validate = await MessageValidation.validate(objectToValidate);

            if (validate !== true) {
                this.setState({
                    erros: validate,
                    messagens: MessageUtil.makeToValidationField(
                        new GeneralTranslation(validate).translate()
                    ),
                });
                return;
            }

            this.setState({
                isConfirmationOpen: true,
                erros: {},
            });
        } catch (e) {
            this.setState({
                messagens: MessageUtil.make({
                    title: 'Atenção',
                    body: e,
                }),
            });
        }
    };

    handleConfirmSend = async () => {
        try {
            this.setState({
                inLoad: true,
                isConfirmationOpen: false,
            });

            let requestBody;
            if (this.state.sendToAll) {
                requestBody = {
                    subject: this.state.form.subject,
                    body: this.state.form.body,
                    send_to_all: true,
                    confirm_all: true,
                };
            } else {
                requestBody = {
                    subject: this.state.form.subject,
                    body: this.state.form.body,
                    client_uuids: this.state.selectedClients,
                };
            }

            await this.messageService.createMessage(requestBody);

            this.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Sucesso',
                    body: 'Mensagem enviada com sucesso.',
                    okBtnToRoute: CreateMensageriaScreen.ROUTE,
                }),
            });
        } catch (e) {
            this.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Atenção',
                    body: e,
                }),
            });
        }
    };

    render() {
        return (
            <>
                <HeaderComponent title={'Mensageria: Nova Mensagem'}
                                 menu={true}
                                 messagens={this.state?.messagens}
                                 inLoad={this.state.inLoad}/>
                <Typography align={'center'}
                            variant={'h6'}
                            color={'primary'}>
                    Nova Mensagem
                </Typography>
                <SpacerComponent height={40}/>
                <CreateFormMensageriaComponent
                    form={this.state.form}
                    onChangeForm={this.handleChangeForm}
                    erros={this.state.erros}
                />
                <TableCreateFormMensageriaComponente
                    clients={this.state.clients}
                    selectedClients={this.state.selectedClients}
                    sendToAll={this.state.sendToAll}
                    pagination={this.state.pagination}
                    onChangePage={(page, search) => this.load(page, search)}
                    onSelectClient={this.handleSelectClient}
                    onSelectAllCurrentPage={this.handleSelectAllCurrentPage}
                    onToggleSendToAll={this.handleToggleSendToAll}
                    erros={this.state.erros}
                />
                <FooterMensageriaComponent
                    isOpen={this.state.isConfirmationOpen}
                    form={this.state.form}
                    selectedClients={this.state.selectedClients}
                    sendToAll={this.state.sendToAll}
                    pagination={this.state.pagination}
                    onReviewAndSend={this.handleReviewAndSend}
                    onBack={() => this.setState({ isConfirmationOpen: false })}
                    onConfirm={this.handleConfirmSend}
                />
            </>
        );
    }
}

CreateMensageriaScreen.propTypes = {};

export default CreateMensageriaScreen;